import { render, staticRenderFns } from "./goodsLink.vue?vue&type=template&id=7c0b43fa&scoped=true&"
import script from "./goodsLink.vue?vue&type=script&lang=js&"
export * from "./goodsLink.vue?vue&type=script&lang=js&"
import style0 from "./goodsLink.vue?vue&type=style&index=0&id=7c0b43fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0b43fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c0b43fa')) {
      api.createRecord('7c0b43fa', component.options)
    } else {
      api.reload('7c0b43fa', component.options)
    }
    module.hot.accept("./goodsLink.vue?vue&type=template&id=7c0b43fa&scoped=true&", function () {
      api.rerender('7c0b43fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recommend/compoments/goodsLink.vue"
export default component.exports